'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var useTimeout = require('../../../hooks/useTimeout.js');
var loader_module = require('../Loader/loader.module.scss.js');
var cx = require('classnames');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var InlineLoader = function (_a) {
    var _b;
    var className = _a.className, darkMode = _a.darkMode, timeout = _a.timeout, timeoutCallback = _a.timeoutCallback, message = _a.message, messageClassName = _a.messageClassName;
    useTimeout.default(timeout, timeoutCallback);
    return (jsxRuntime.jsxs("div", tslib.__assign({ className: cx__default.default(loader_module.default['inline-loader'], loader_module.default.preloader, className, (_b = {}, _b["".concat(loader_module.default.dark)] = darkMode, _b), 'd-inline-block'), "data-testid": "inline-loader" }, { children: [jsxRuntime.jsxs("div", tslib.__assign({ className: "d-flex justify-content-start" }, { children: [jsxRuntime.jsx("div", { className: "".concat(loader_module.default.square, " ").concat(loader_module.default.first) }), jsxRuntime.jsx("div", { className: loader_module.default.square }), jsxRuntime.jsx("div", { className: loader_module.default.square }), jsxRuntime.jsx("div", { className: loader_module.default.square }), jsxRuntime.jsx("div", { className: "".concat(loader_module.default.square, " ").concat(loader_module.default.last) })] })), message && (jsxRuntime.jsx("p", tslib.__assign({ className: cx__default.default(loader_module.default.message, 'mb-0', 'mt-2', messageClassName) }, { children: message })))] })));
};
InlineLoader.defaultProps = {
    darkMode: false,
    className: '',
    messageClassName: ''
};
var InlineLoader$1 = InlineLoader;

exports.default = InlineLoader$1;
//# sourceMappingURL=InlineLoader.js.map
